import Image from 'next/image'
import { forwardRef } from 'react'

import { OlbyLines } from '../../../assets/icons'
import CTAButton from '../../button'

import styles from './index.module.scss'

export const ReadyToSayHelloTalentSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['section-wrapper']} ref={ref}>
      <div className={styles['content']}>
        <h2 className={styles['title']}>
          Ready to say <span className={styles['highlight']}>“hello”</span> to a new adventure?
        </h2>
        <CTAButton href="/talent" variant="primary" className={styles['button']} prefetch={false}>
          join Olby
        </CTAButton>
        <CTAButton
          href="/talent"
          variant="primary"
          size="medium"
          className={styles['mobile-button']}
          prefetch={false}
        >
          join Olby
        </CTAButton>
        <OlbyLines className={styles['left-lines']} />
        <OlbyLines className={styles['right-lines']} />
        <div className={styles['image-wrapper']}>
          <div className={styles['image-container']}>
            <Image
              src="https://platform-statics.olby.com/hello-talent.png"
              fill
              sizes="(max-width: 1279px) 24.8rem, 35.2rem"
              className={styles['image']}
              alt="Woman smiling on a call using a notebook"
            />
          </div>
        </div>
      </div>
    </section>
  )
})
